import * as NUMBERS from 'constant/number'
import * as ROUTES from 'constant/routes'
import { SettingOutlined, QuestionCircleOutlined, LogoutOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useHistory } from 'react-router-dom'
import { logout } from 'action/auth'
import { Menu, Dropdown, Avatar } from 'antd'
import React, { useState } from 'react'
import Settings from 'view/component/settings'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import styles from './index.scss'

// eslint-disable-next-line max-lines-per-function
/* eslint-disable complexity */
const UserAvatar = ({ user, help, logout, inPlcp = false }) => {
  const history = useHistory()

  const [isSettingModalVisible, setSettingModalVisible] = useState(false)
  const handleOpenSettings = () => setSettingModalVisible(true)
  const handleCloseSettings = () => setSettingModalVisible(false)

  return (
    <Dropdown
      className={inPlcp ? 'd-block' : 'd-none d-md-block d-lg-block'}
      overlay={(
        <Menu>
          <Menu.Item
            icon={<SettingOutlined />}
            label='Settings'
            onClick={handleOpenSettings}
          >
            Profile
          </Menu.Item>
          {inPlcp && <>
            <Menu.Item
              className={styles.logout_link}
              icon={<LogoutOutlined />}
              label='Logout'
              onClick={logout}
            >
                      Logout
            </Menu.Item>
          </>}
          {help && help.show
          ? <>
            <Menu.Item
              icon={<QuestionCircleOutlined />}
              onClick={() => history.push(ROUTES.HELP)}
            >
            Help
            </Menu.Item>
          </>
          : <></>
          }
          <Settings
            handleClose={handleCloseSettings}
            handleOpen={handleOpenSettings}
            inPlcp={inPlcp}
            isModalVisible={isSettingModalVisible}
          />
        </Menu>
      )}
      placement={inPlcp ? 'bottomRight' : 'bottomLeft'}
      trigger={['click']}
    >
      <Avatar
        className={classnames(styles.username)}
        shape='square'
        size='large'
      >
        {user ? `${user.first_name[NUMBERS.ZERO].toUpperCase()}${user.last_name[NUMBERS.ZERO].toUpperCase()}` : 'U'}
      </Avatar>
    </Dropdown>
  )
}

UserAvatar.propTypes = {
  help: PropTypes.object,
  inPlcp: PropTypes.bool,
  logout: PropTypes.func,
  user: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    help: state.help.help
  }
}

const mapDispacthToProps = (dispatch) => ({
  logout: bindActionCreators(logout, dispatch)
})

export default connect(mapStateToProps, mapDispacthToProps)(UserAvatar)
